__turbopack_context__.v({
  "Bottom": "HorizontalRule-module__HgZ-bW__Bottom",
  "Decoration": "HorizontalRule-module__HgZ-bW__Decoration",
  "None": "HorizontalRule-module__HgZ-bW__None",
  "Top": "HorizontalRule-module__HgZ-bW__Top",
  "curve": "HorizontalRule-module__HgZ-bW__curve",
  "root": "HorizontalRule-module__HgZ-bW__root",
});
